"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchWorkflowFeature = void 0;
const react_1 = __importDefault(require("react"));
const TAAErrorBoundary_1 = require("../../components/Shared/TAAErrorBoundary");
const contexts_1 = require("../../contexts");
const PunchWorkflow_1 = require("../../components/PunchWorkflow");
const logger_1 = require("../../logger");
const PunchWorkflowFeature = ({ selectedDateTime, featureGates = {
    ctkPolicy: false,
    useUnifiedPunchesAPIForWeb: false,
    useUnifiedPunchesAPIForNative: false,
    isSubmitMissedPunchEnabled: false,
    isSubmitMissedPunchV2Enabled: false,
    isDeleteDupePunchEnabled: false,
    isDeleteMpcaMpcsForWebEnabled: false,
    isDeleteMpcaMpcsForNativeEnabled: false,
    isPunchCorrStatusEnabled: false,
    isPunchEditForNativeEnabled: false,
    isPunchEditForWebEnabled: false,
    shouldShowRoundedPunch: false,
    isATPlusTemporalRoutingEnabled: false
} }) => {
    const { associateInfo } = (0, contexts_1.useTaaConfigsContext)();
    (0, logger_1.useComponentLoadedMetrics)({
        metricNames: {
            countMetricName: logger_1.METRICS.PUNCH_WORKFLOW.COUNT,
            latencyMetricName: logger_1.METRICS.PUNCH_WORKFLOW.LATENCY
        },
        isComponentLoaded: true
    });
    (0, logger_1.useLogAppLatencyCF)('AtoZPunchWorkflow');
    return (react_1.default.createElement(TAAErrorBoundary_1.TAAErrorBoundary, null,
        react_1.default.createElement(PunchWorkflow_1.PunchWorkflow, { selectedDateTime: selectedDateTime, associateInfo: associateInfo, featureGates: featureGates })));
};
exports.PunchWorkflowFeature = PunchWorkflowFeature;
